import * as React from 'react';

// API
import apibridge from '../../../apibridge';

// UTILS
import { validationErrorsToString } from '../../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import LoadingSpinner from '../../../components/LoadingSpinner';

// TYPES
import { ComplaintAcceptResolutionResolution } from '../../../api/models';

interface ViewResolutionModalTypes {
	complaintId?: string;
}

const ViewResolutionModal: React.FC<ViewResolutionModalTypes> = ({ complaintId }) => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	// Set up data state and initial data
	const initialData = {
		resolver: '',
		proposal: '',
		notes: ''
	};

	const [resolutionReviewDetail, setResolutionReviewDetail] =
		React.useState<ComplaintAcceptResolutionResolution>(initialData);

	const getResolutionReviewDetail = async () => {
		setIsLoading(true);

		const response = await apibridge.getResolutionReviewDetail(complaintId);

		response.result = response.result || initialData;

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			setResolutionReviewDetail(response.result);
		}
	};

	React.useEffect(() => {
		getResolutionReviewDetail();
	}, []);

	const { resolver, proposal, notes } = resolutionReviewDetail;

	return (
		<>
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<div className="complaints-detail">
									<div className="detail-block">
										<h2 className="detail-heading">{resolver} proposes that</h2>

										<p className="detail-info">{proposal}</p>
									</div>
								</div>

								<div className="complaints-detail">
									<div className="detail-block">
										<h2 className="detail-heading">Notes</h2>

										<p className="detail-info">{notes}</p>
									</div>
								</div>
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</>
	);
};

export default ViewResolutionModal;
